import { useQuery } from "@tanstack/react-query";
import { useStoreScope } from "@/hooks/use-store-context";
import { api } from "../runtime";
import type { AppointmentListItem } from "../types";
import { qk } from "./keys";

export const APPOINTMENT_VIEWS = ["today", "upcoming", "confirmed", "needs_confirmation", "reschedule", "no_show", "arrived"] as const;
export type AppointmentView = (typeof APPOINTMENT_VIEWS)[number];

/** [planned] GET /v1/appointments?view= */
export function useAppointments(view: AppointmentView) {
  const scope = useStoreScope();
  return useQuery({
    queryKey: qk.appointments.list(scope, { view }),
    queryFn: async () => (await api.get<{ items: AppointmentListItem[] }>("/v1/appointments", { query: { view } })).items,
    retry: false,
  });
}
